<template>
  <div>
    <p :class="classesCount">{{ count }}</p>
    <button @click="sub">-</button>
    <button @click="add">+</button>
  </div>
</template>

<script>
    import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

    export default {
        name: "Counter",
        computed: {
            ...mapState(["count"]),
            ...mapGetters(['isPositive', 'isNegative']),
            classesCount () {
                return {
                    'blue': this.isPositive,
                    'red': this.isNegative
                }
            }
        },
        methods: {
            ...mapMutations(['increment','decrement']),
            ...mapActions(['addAsync', 'subAsync']),
            add () {
                this.increment()

                this.addAsync({
                    amount: 1000
                })
            },
            sub () {
                this.decrement()

                this.subAsync({
                    amount: 1000
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
  .red {
    color: red;
  }
  .blue {
    color: blue;
  }
</style>